import { Record } from 'immutable';
export function makeScopeKey(scopeKey) {
  return scopeKey;
}
const MarketplaceScopeConstructor = Record({
  name: '',
  description: ''
});
export const defaultMarketplaceScope = MarketplaceScopeConstructor();
export const makeMarketplaceScope = a => MarketplaceScopeConstructor(a);